export default __webpack_public_path__ + "static/media/image-ph-health-statistics-w@2x.1ada62af.png";